import Moment from 'moment'
import { Notification } from 'element-ui'
import base from '@/api/base'
import $api from '@/api'
import bus from '@/bus'

const STORAGE_KEY = 'NEW_ORDER_LAST_CHECK_TIME'
const ENABLED_KEY = 'NEW_ORDER_NOTIFY_ENABLED'
const POLL_INTERVAL = 120000
// 仅该账号默认开启新订单语音提醒，其余账号默认关闭
const DEFAULT_ENABLED_ACCOUNT = '景德镇珠山大道分店'

class NewOrderNotifyService {
  constructor() {
    this.timer = null
    this.running = false
    this.unlocked = false
    this.newOrderCount = 0
    this.account = ''
  }

  setAccount(account) {
    this.account = account || ''
  }

  isEnabled() {
    const stored = sessionStorage.getItem(ENABLED_KEY)
    if (stored === null) {
      // 未手动设置时，按账号决定默认值
      return this.account === DEFAULT_ENABLED_ACCOUNT
    }
    return stored !== 'false'
  }

  setEnabled(enabled) {
    sessionStorage.setItem(ENABLED_KEY, enabled ? 'true' : 'false')
  }

  unlockAudio() {
    this.unlocked = true
    this.speak('新订单语音提醒已开启')
  }

  speak(text) {
    if (!this.isEnabled() || !this.unlocked || !window.speechSynthesis) {
      return
    }
    window.speechSynthesis.cancel()
    const utterance = new SpeechSynthesisUtterance(text)
    utterance.lang = 'zh-CN'
    utterance.rate = 1
    window.speechSynthesis.speak(utterance)
  }

  getSinceTime() {
    return sessionStorage.getItem(STORAGE_KEY) || Moment().format('YYYY-MM-DD HH:mm:ss')
  }

  initSinceTime() {
    if (!sessionStorage.getItem(STORAGE_KEY)) {
      sessionStorage.setItem(STORAGE_KEY, Moment().format('YYYY-MM-DD HH:mm:ss'))
    }
  }

  start(onCountChange) {
    if (this.running) {
      return
    }
    this.running = true
    this.onCountChange = onCountChange
    this.initSinceTime()
    this.poll()
    this.timer = setInterval(() => this.poll(), POLL_INTERVAL)
  }

  stop() {
    this.running = false
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    this.newOrderCount = 0
    if (this.onCountChange) {
      this.onCountChange(0)
    }
  }

  async poll() {
    if (!this.isEnabled()) {
      return
    }
    const sinceTime = this.getSinceTime()
    try {
      const { data } = await $api.PRESCRIPTIONDRUG.checkNewOrders({
        appCode: base.appCode,
        sinceTime
      })
      const serverTime = (data && data.serverTime) || Moment().format('YYYY-MM-DD HH:mm:ss')
      sessionStorage.setItem(STORAGE_KEY, serverTime)

      const count = (data && data.count) || 0
      if (count > 0) {
        this.handleNewOrders(count, data.latestList || [])
      }
    } catch (error) {
      console.log('new order notify poll error', error)
    }
  }

  handleNewOrders(count, latestList) {
    this.newOrderCount = count
    if (this.onCountChange) {
      this.onCountChange(count)
    }

    const first = latestList[0] || {}
    const patientName = first.patientName ? `，患者${first.patientName}` : ''
    this.speak(`您有${count}条新处方订单${patientName}`)

    Notification({
      title: '新处方提醒',
      message: `收到 ${count} 条新处方订单${patientName}`,
      type: 'warning',
      duration: 8000,
      position: 'top-right'
    })

    bus.$emit('new-prescription-orders', { count, latestList })
  }

  clearBadge() {
    this.newOrderCount = 0
    if (this.onCountChange) {
      this.onCountChange(0)
    }
  }
}

export default new NewOrderNotifyService()



// WEBPACK FOOTER //
// ./src/utils/newOrderNotify.js